/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Bi_Authoring_Unrestricted_DescInputs */



/**
* | output |
* | --- |
* | "Dashboard authoring is open to all organisation members again." |
*
* @param {Audit_Details_Bi_Authoring_Unrestricted_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_bi_authoring_unrestricted_desc = /** @type {((inputs?: Audit_Details_Bi_Authoring_Unrestricted_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Bi_Authoring_Unrestricted_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Das Erstellen von Dashboards steht wieder allen Mitgliedern der Organisation offen.")
	return /** @type {LocalizedString} */ ("Dashboard authoring is open to all organisation members again.")
});